import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { IS_USE_PLEX_API } from '../../constants';
import { gamesStoreActions, useGetIsWagerSlotGamesLoaded } from '../../store';
import { useGetLoadFeedGamesCallback } from '../useGetLoadFeedGamesCallback';
import { useGetShowWagerSlotsCategory } from '../useGetShowWagerSlotsCategory';

const { GET_WAGER_SLOT_GAMES } = gamesStoreActions;

export const useLoadWagerSlotsGames = (feedName, limit) => {
  const [isLoading, setIsLoading] = useState(false);
  const isWagerSlotGamesLoaded = useGetIsWagerSlotGamesLoaded();
  const showWagerSlotsCategory = useGetShowWagerSlotsCategory();
  const fetchGamesPlex = useGetLoadFeedGamesCallback();

  useEffect(() => {
    (async () => {
      if (!isWagerSlotGamesLoaded && showWagerSlotsCategory && !isLoading) {
        setIsLoading(true);

        const gamesLaunchIds = await GET_WAGER_SLOT_GAMES();

        if (IS_USE_PLEX_API && !isEmpty(gamesLaunchIds)) {
          fetchGamesPlex({
            filter: { launchId: gamesLaunchIds.slice(0, limit), limit }
          });
        }
        setIsLoading(false);
      }
    })();
  }, [
    isWagerSlotGamesLoaded,
    showWagerSlotsCategory,
    fetchGamesPlex,
    feedName
  ]);
};
